
export enum Type {
    Info = 'Info',
    Init = 'Init',
    BaselineExemption = "BaselineExemption"
}